/**
 * apiConfig: {
 *     appName: '',
 *     modelName: '',
 *     version: 1
 * }
 */
import base from './base.js'

class ModelService {

  constructor (appName, modelName, version) {
    this.appName = appName
    this.modelName = modelName
    this.version = version
    this.getModelList = this.getModelList.bind(this)
    this.getModelDetail = this.getModelDetail.bind(this)
    this.deleteModel = this.deleteModel.bind(this)
    this.updateModel = this.updateModel.bind(this)
    this.loadModelOptions = this.loadModelOptions.bind(this)
  }

  getModelList(cond, successCallback, failCallback) {
    base.verifiedRequest({
      path: '/api/' + this.appName + '/v' + this.version + '/' + this.modelName + '/list/',
      method: 'GET',
      data: cond,
      success: function (res) {
        successCallback && successCallback(res)
      },
      fail: function (msg) {
        if (failCallback) {
          failCallback(msg)
        } else {
          alert(msg)
        }
      }
    })
  }

  getModelDetail(cond, successCallback, failCallback) {
    base.verifiedRequest({
      path: '/api/' + this.appName + '/v' + this.version + '/' + this.modelName + '/detail/',
      method: 'GET',
      data: cond,
      success: function (res) {
        successCallback && successCallback(res)
      },
      fail: function (msg) {
        if (failCallback) {
          failCallback(msg)
        } else {
          alert(msg)
        }
      }
    })
  }

  deleteModel(cond, successCallback, failCallback) {
    base.verifiedRequest({
      path: '/api/' + this.appName + '/v' + this.version + '/' + this.modelName + '/delete/',
      method: 'POST',
      data: cond,
      success: function (res) {
        successCallback && successCallback(res)
      },
      fail: function (msg) {
        if (failCallback) {
          failCallback(msg)
        } else {
          alert(msg)
        }
      }
    })
  }

  updateModel(params, successCallback, failCallback) {
    base.verifiedRequest({
      path: '/api/' + this.appName + '/v' + this.version + '/' + this.modelName + '/update/',
      method: 'POST',
      data: params,
      success: function (res) {
        successCallback && successCallback(res)
      },
      fail: function (msg) {
        if (failCallback) {
          failCallback(msg)
        } else {
          alert(msg)
        }
      }
    })
  }

  loadModelOptions(successCallback, failCallback) {
    base.verifiedRequest({
      path: '/api/' + this.appName + '/v' + this.version + '/' + this.modelName + '/options',
      method: 'GET',
      data: {},
      success: function (res) {
        successCallback && successCallback(res)
      },
      fail: function (msg) {
        if (failCallback) {
          failCallback(msg)
        } else {
          alert(msg)
        }
      }
    })
  }

  loadModelFieldSpec(successCallback, failCallback) {
    base.verifiedRequest({
      path: '/api/' + this.appName + '/v' + this.version + '/' + this.modelName + '/fieldspec',
      method: 'GET',
      data: {},
      success: function (res) {
        successCallback && successCallback(res)
      },
      fail: function (msg) {
        if (failCallback) {
          failCallback(msg)
        } else {
          alert(msg)
        }
      }
    })
  }
}

export default {
  ModelService: ModelService
}



// WEBPACK FOOTER //
// ./src/service/crud.js